import {
  Type,
  FileText,
  HelpCircle,
  List,
  BarChart,
  Phone,
  Store,
  LayoutGrid,
  CreditCard,
  ListChecks,
  Monitor,
  Megaphone,
  ShieldCheck,
} from "lucide-react";

export interface SectionTypeConfig {
  type: string;
  label: string;
  description: string;
  color: string;
  Icon: React.ComponentType<{ size?: number }>;
  createDefault: () => Record<string, unknown>;
}

export const SECTION_TYPES: SectionTypeConfig[] = [
  {
    type: "hero",
    label: "Cabeçalho",
    description: "Título principal da página com subtítulo opcional",
    color: "bg-blue-100 text-blue-700",
    Icon: Type,
    createDefault: () => ({
      heading: "",
      subtext: "",
      lastUpdated: "",
      image: "",
      imageAlt: "",
    }),
  },
  {
    type: "richtext",
    label: "Texto Rico",
    description: "Bloco de HTML livre para conteúdo formatado",
    color: "bg-gray-100 text-gray-700",
    Icon: FileText,
    createDefault: () => ({ html: "" }),
  },
  {
    type: "faq_list",
    label: "FAQ",
    description: "Lista de perguntas e respostas",
    color: "bg-purple-100 text-purple-700",
    Icon: HelpCircle,
    createDefault: () => ({ items: [] }),
  },
  {
    type: "sections_list",
    label: "Lista de Secções",
    description: "Secções com título e corpo de texto",
    color: "bg-green-100 text-green-700",
    Icon: List,
    createDefault: () => ({ items: [] }),
  },
  {
    type: "stats_grid",
    label: "Grelha de Estatísticas",
    description: "Conjunto de métricas com rótulo e valor",
    color: "bg-orange-100 text-orange-700",
    Icon: BarChart,
    createDefault: () => ({ items: [] }),
  },
  {
    type: "contact_info",
    label: "Contactos",
    description: "Informações de contacto telefone, email e morada",
    color: "bg-teal-100 text-teal-700",
    Icon: Phone,
    createDefault: () => ({ phone: "", phoneNote: "", email: "", address: "" }),
  },
  {
    type: "stores_list",
    label: "Lojas",
    description: "Lista de lojas com morada, horário e mapa",
    color: "bg-pink-100 text-pink-700",
    Icon: Store,
    createDefault: () => ({ intro: "", footnote: "", items: [] }),
  },
  {
    type: "services_grid",
    label: "Grelha de Serviços",
    description: "Conjunto de serviços com título, descrição e ícone",
    color: "bg-indigo-100 text-indigo-700",
    Icon: LayoutGrid,
    createDefault: () => ({ heading: "", items: [] }),
  },
  {
    type: "payment_methods",
    label: "Métodos de Pagamento",
    description: "Métodos de pagamento aceites",
    color: "bg-yellow-100 text-yellow-700",
    Icon: CreditCard,
    createDefault: () => ({ intro: "", items: [] }),
  },
  {
    type: "bullet_list",
    label: "Lista de Tópicos",
    description: "Lista simples de itens de texto",
    color: "bg-cyan-100 text-cyan-700",
    Icon: ListChecks,
    createDefault: () => ({ items: [] }),
  },
  {
    type: "product_grid",
    label: "Grelha de Produtos",
    description:
      "Listagem dinâmica de máquinas do catálogo (por marca/categoria)",
    color: "bg-amber-100 text-amber-700",
    Icon: Monitor,
    createDefault: () => ({
      heading: "",
      subtext: "",
      brand: "",
      categories: ["computer-gaming"],
      limit: 24,
      ctaHref: "",
      ctaLabel: "",
    }),
  },
  {
    type: "hero_banner",
    label: "Banner Hero",
    description:
      "Banner de marca com imagem, badge, subtítulo, CTA e nota de confiança",
    color: "bg-rose-100 text-rose-700",
    Icon: Megaphone,
    createDefault: () => ({
      badge: "",
      heading: "",
      subtext: "",
      image: "",
      imageAlt: "",
      ctaHref: "",
      ctaLabel: "",
      trustNote: "",
      accent: "orange",
    }),
  },
  {
    type: "callout",
    label: "Destaque",
    description: "Cartão destacado com ícone, título e texto rico",
    color: "bg-emerald-100 text-emerald-700",
    Icon: ShieldCheck,
    createDefault: () => ({
      icon: "",
      heading: "",
      html: "",
      accent: "orange",
    }),
  },
  {
    type: "feature_cards",
    label: "Cartões de Destaque",
    description: "Grelha de cartões com ícone, título e descrição",
    color: "bg-lime-100 text-lime-700",
    Icon: LayoutGrid,
    createDefault: () => ({ heading: "", items: [], accent: "orange" }),
  },
];

export const SECTION_TYPE_MAP = new Map(SECTION_TYPES.map((t) => [t.type, t]));
